<template>
	<h1>LocationRequired</h1>
</template>